import { styled } from '@linaria/react'

export const SlidingTitleSC = styled.div`
  position: relative;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
`

export const SlidingTitleContentSC = styled.span<{ $sliding?: boolean }>`
  display: inline-block;
  white-space: nowrap;
  will-change: ${({ $sliding }) => ($sliding ? 'transform' : 'auto')};
  animation: sliding-title-loop var(--sliding-title-duration, 8s) ease-in-out
    infinite;
  animation-play-state: ${({ $sliding }) => ($sliding ? 'running' : 'paused')};

  @keyframes sliding-title-loop {
    0%,
    10% {
      transform: translateX(0);
    }

    45%,
    55% {
      transform: translateX(calc(-1 * var(--sliding-title-distance, 0px)));
    }

    90%,
    100% {
      transform: translateX(0);
    }
  }
`
